import React from 'react';
import { useSearchParams } from 'react-router-dom';

import CustomTabPanel from 'components/Shared/CustomTabPanel';
import CustomTabs from 'components/Shared/CustomTabs';
import RowsSkeleton from 'components/Shared/Skeleton/RowsSkeleton';
import NoteTab from '../../../Note/Notetab';

import { useGetNotesBySourceQuery } from 'store/services/noteApi';


import { useGetDocumentsBySourceQuery } from "store/services/documentApi";
import DocumentsTab from "../../../Document/DocumentTab";

import { useCodTransferDetailContext } from "contexts/PaymentContexts/CodTransferContext";
import CodTransferShipmentList from "./CodTransferShipmentList";
import CodTransferEBillTab from "./CodTransferEBillTab";

const CodTransferDetailTab = () => {

  const [searchParams] = useSearchParams();

  const activeTab = searchParams.get('tab') || 'note';

 const { CodTransferDetail } =useCodTransferDetailContext();

  // Fetch notes to get the count for the badge
  const { data: notes } = useGetNotesBySourceQuery(
    { source: 'CODTransfer', sourceRef: CodTransferDetail?._id, }, { skip: !CodTransferDetail?._id }
  );

  // Fetch documents to get the count for the badge
  const { data: documents } = useGetDocumentsBySourceQuery(
    { source: 'CODTransfer', sourceRef: CodTransferDetail?._id, }, { skip: !CodTransferDetail?._id }
  );

  const tabs = [
    {
      label: 'Note',
      value: 'note',
      badgeCount: notes?.length || 0,
    },
    { label: "Document", value: "document", badgeCount: documents?.totalItems },

    { label: "Shipment", value: "shipment", badgeCount: CodTransferDetail?.shipmentId?.length },
    ...(CodTransferDetail?.eBillId
      ? [{ label: "EBill", value: "ebill", badgeCount: 1 }]
      : []),
  ];

  return (
    <>
      <CustomTabs tabs={tabs} activeTab={activeTab} />

      {CodTransferDetail ? (
        <>
          <CustomTabPanel activeTab={activeTab} value="note">
            <NoteTab source="CODTransfer" sourceRef={CodTransferDetail._id} />
          </CustomTabPanel>

          <CustomTabPanel activeTab={activeTab} value="document">
            <DocumentsTab source="CODTransfer" sourceRef={CodTransferDetail._id} />
          </CustomTabPanel>

          <CustomTabPanel activeTab={activeTab} value="shipment">
          <CodTransferShipmentList/>
          </CustomTabPanel>

          <CustomTabPanel activeTab={activeTab} value="ebill">
            <CodTransferEBillTab />
          </CustomTabPanel>

        </>
      ) : (
        <RowsSkeleton />
      )}
    </>
  );
};

export default CodTransferDetailTab;
